import { useState } from "react";
import { Table } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";

const GamMappingList = ({ mappingList, payload }) => {
    // const [selectedRows, setSelectedRows] = useState([]);
    const [selectedData, setSelectedData] = useState([]);

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const param = useParams();

    let pubId = 0;
    let gamId = 0;
    let inclusionStatus = -1;

    if (queryParams.size > 0) {
        pubId = queryParams.get("accountId");
        gamId = queryParams.get("gamAccountId");
        inclusionStatus = queryParams.get("inclusionStatus");
    } else {
        pubId = param?.pubId;
        gamId = param?.gamId;
        inclusionStatus = param?.showGamMapping;
    }

    const selectItems = (prev, item) => {
        const exists = prev.find(
            data => data.name === item.name && data.domain === item.domain
        );

        if (exists) {
            // remove if unchecked
            return prev.filter(
                data => !(data.name === item.name && data.domain === item.domain)
            );
        } else {
            return [...prev, item];
        }
    }

    // selected checkbox details
    const handleCheckboxChange = (row) => {
        const item = {
            name: row?.name,              // map from table field
            domain: row?.domain,
            inclusionStatus: Number(row?.inclusionStatus)
        };

        const selectedItems = selectItems(selectedData, item);
        setSelectedData(selectedItems);
        payload({
            accId: Number(pubId),
            selectedData: selectedItems,
            gamAccountId:Number(gamId),
            inclusionStatus: Number(inclusionStatus),
        });
    };
    // console.log(selectedData);

    return (
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            <Table bordered hover size="sm">
                <thead style={{ background: "#ddd", position: "sticky", top: 0 }}>
                    <tr>
                        <th style={{ width: "50px" }}></th>
                        <th>Domain</th>
                        <th>Ad Unit</th>
                        <th>Display Ad Unit | Date</th>
                        <th>Page Views Setting</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {mappingList.map((row) => (
                        <tr key={row?.adUnit}>
                            <td>
                                <input type="checkbox" id={row?.gamId} checked={selectedData?.some(
                                    data => data.name === row.name && data.domain === row.domain
                                )}
                                    onChange={() => handleCheckboxChange(row)} />
                            </td>
                            <td>{row?.domain}</td>
                            <td>{row?.adUnit}</td>
                            <td>{row?.renameAdUnit}
                                {row?.renameAdUnit ? " | " : ""}
                                {row?.renameAdUnitDate}</td>
                            <td>{row?.pageViewsDate ?
                                `${row?.pageViewsCount===0 ? "Ad Request | " : "Impression | "}
                                ${row?.pageViewsType === 1 ? "Video |" : "Display |"}
                                ${row?.pageViewsStatus === 1 ? "Active | " : "Pending | "}
                                ${row?.pageViewsDate}`
                                : ''}
                            </td>
                            <td>{row?.inclusionStatus === 0 ? 'Inclusion' : 'Exclusion'}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div style={{ background: "#e0e0e0", border: "1px solid #ababab", bordertop: "none", padding: "3px" }}>
                Total size : {mappingList.length}
            </div>
        </div>
    );
}

export default GamMappingList;